import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./fonts.ts";
import "@mantine/core/styles.css";

import * as errorMonitoring from "./utils/error-monitoring";
import * as tagManager from "./utils/tag-manager/index.ts";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App.tsx";
import { Auth0Provider } from "@auth0/auth0-react";
import { MantineProvider } from "@mantine/core";
import { PostHogProvider } from "posthog-js/react";
import ReactDOM from "react-dom/client";
import { envConfig } from "./config/envConfig.ts";
import { initializePosthog } from "./utils/analytics/posthog.ts";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      retry: false,
    },
  },
});

const posthog = initializePosthog();
errorMonitoring.initializeBugsnag();
tagManager.initialize();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <MantineProvider>
    <QueryClientProvider client={queryClient}>
      <Auth0Provider
        domain={envConfig.auth0Domain}
        clientId={envConfig.auth0ClientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: envConfig.auth0Audience,
        }}
      >
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      </Auth0Provider>
    </QueryClientProvider>
  </MantineProvider>,
);
